import {
  StyledInputWrapper,
  StyledInputLabel,
  StyledTextArea,
  StyledFormItemField,
} from "./style";
import type { TextInputFieldProps } from "./interfaces";
import { useState, useEffect } from "react";

export const TextAreaField = (props: TextInputFieldProps) => {
  const [inputValue, setInputValue] = useState(props.value);

  useEffect(() => {
    setInputValue(props.value);
  }, [props.value]);

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement> | undefined
  ) => {
    let newValue = e?.target.value;
    if (newValue !== undefined) {
      setInputValue(newValue);
      if (props.onChange) {
        props.onChange(newValue);
      }
    }
  };

  return (
    <StyledInputWrapper>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}

      <StyledFormItemField name={props.name} rules={props.rules}>
        <StyledTextArea
          placeholder={props.placeholder}
          defaultValue={props.value}
          readOnly={!props.isEditable}
          value={inputValue}
          onChange={handleChange}
          rows={6}
        />
      </StyledFormItemField>
    </StyledInputWrapper>
  );
};
